var React = require('react');

function TagLabel (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/Tag with dropdown"),React.createElement("path",{"transform":"translate(24,0) scale(-1,1)","d":"M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z","key":1}),React.createElement("path",{"d":"M15.5 20.5L21.5 20.5L18.5 24z","key":2})]);
}

TagLabel.defaultProps = {"width":"24px","height":"25px","viewBox":"0 0 24 25","version":"1.1"};

module.exports = TagLabel;

TagLabel.default = TagLabel;
